/** PortfolioSelection — bucket picker inside the manual approval panel. */
export default function PortfolioSelection({ portfolios, portfolioKey, onSelect }) {
  return (
    <div className="mt-3">
      <div className="label-cap mb-1" id="portfolio-picker-label">Portfolio</div>
      <div
        className="grid grid-cols-1 sm:grid-cols-3 gap-px bg-border/40"
        data-testid="portfolio-picker"
        role="radiogroup"
        aria-labelledby="portfolio-picker-label"
      >
        {portfolios.map((p) => {
          const sel = portfolioKey === p.key;
          return (
            <button
              key={p.key}
              type="button"
              role="radio"
              aria-checked={sel}
              onClick={() => onSelect(p.key)}
              className={`p-2 text-left transition-colors focus:outline-none focus:ring-1 focus:ring-current ${sel ? "bg-secondary/50" : "bg-card/40 hover:bg-secondary/25"}`}
              data-testid={`portfolio-pick-${p.key}`}
            >
              <div className="flex items-center gap-2">
                <div className={`w-1 h-3 ${sel ? "bg-[#0A84FF]" : "bg-transparent"}`} aria-hidden="true"/>
                <div className="mono uppercase text-[11px]">{p.name}</div>
                <div className="ml-auto mono text-[10px] text-muted-foreground">{p.allocation_pct}%</div>
              </div>
              <div className="mono text-xs mt-1">${(p.available_cash || 0).toLocaleString(undefined, { maximumFractionDigits: 0 })}</div>
            </button>
          );
        })}
      </div>
    </div>
  );
}
